module.exports = __webpack_public_path__ + "media/8_Long.781e38ab.mp3";